// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import firebase from 'firebase/compat/app';
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

/*
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
*/




// TODO: Add SDKs for Firebase products.jsx that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBaaVvfWo_TjkxqLiSaTejYqrG5M-powDQ",
  authDomain: "homebase-5f9b2.firebaseapp.com",
  databaseURL: "https://homebase-5f9b2-default-rtdb.firebaseio.com",
  projectId: "homebase-5f9b2",
  storageBucket: "homebase-5f9b2.appspot.com",
  messagingSenderId: "177370550678",
  appId: "1:177370550678:web:44f1650358e936f6334db7"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);

//export const storageRef = firebase.storage().ref();
 



/* 


 */


export default app

